var HistorizedQuery = /** @class */ (function () {
    function HistorizedQuery(versionId) {
        this.versionId = versionId;
    }
    Object.defineProperty(HistorizedQuery.prototype, "searchParams", {
        get: function () {
            return new URLSearchParams([this.versionId !== null ? ['data-version-id', String(this.versionId)] : ['', '']]);
        },
        enumerable: false,
        configurable: true
    });
    return HistorizedQuery;
}());
export { HistorizedQuery };
